import type { PropsWithClassName } from '@fv/client-types'

export const OrDivider = ({ className = '' }: PropsWithClassName) => {
  return (
    <span
      className={`flex items-center rounded-full bg-fv-beer-xlight border-fv-beer-medium border-2 w-7 h-7 text-[.7rem] justify-center leading-none ${className}`}
    >
      OR
    </span>
  )
}
